module.exports = __webpack_public_path__ + "static/media/banner-manual-do-transportador-maxi-frete.3a86137a.png";